import { UseMutationOptionsFromProvider, useMutationEndpoint } from '../../core'
import { postAccessManagementAccountPin } from '../endpoints'

type EndpointParams = Parameters<typeof postAccessManagementAccountPin>[0]
type HookParams = Pick<EndpointParams, 'apiVersion'>
type MutationVariables = Pick<EndpointParams, 'data'>

export const useAccessManagementAccountPinPostMutation = (
  { apiVersion }: HookParams,
  options?: UseMutationOptionsFromProvider<
    typeof postAccessManagementAccountPin,
    MutationVariables
  >,
) =>
  useMutationEndpoint(
    ({ data }: MutationVariables) =>
      postAccessManagementAccountPin({ apiVersion, data }),
    options,
  )
